import { Hangeul } from "./hangeul/index.js";
export function matchText(text, searchText, opts = { korean: true }) {
    if (opts.korean && Hangeul) {
        return (Hangeul.includes(text, searchText) ||
            Hangeul.startsWith(text, searchText, { firstConsonantOnly: true }));
    }
    return text.toLowerCase().includes(searchText.toLowerCase());
}
